
    const data = {"name":"src/core/icons/calendar-check-outline","data":{"viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M19 3h-1V1h-2v2H8V1H6v2H5c-1.1 0-2 .9-2 2v14a2 2 0 0 0 2 2h14c1.11 0 2-.89 2-2V5a2 2 0 0 0-2-2m0 16H5V9h14v10M5 7V5h14v2H5m5.56 10.46 5.94-5.93-1.07-1.06-4.87 4.87-2.11-2.11-1.06 1.06 3.17 3.17Z\"/>","originalColors":[],"stopColors":[]}}

            export default data
            